module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8f4Xp"))).then(() => parcelRequire('d0iPb'));